var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-widget',{staticClass:"d-none d-sm-flex"}),_c('lms-widget'),_c('user-base',{attrs:{"id":"manageUser"}}),_c('group-user'),(_vm.user.dealer_id !== 67)?_c('webinar-cal',{attrs:{"id":"event-calendar"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }